var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRevert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_revert") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.6842105,10.6558704 C14.6842105,12.9230769 12.9515303,14.7368421 10.831545,14.7368421 L9.16001812,14.7368421 C8.99694233,14.7368421 8.89501996,14.6072874 8.89501996,14.4345479 L8.89501996,13.7435897 C8.89501996,13.5708502 9.0173268,13.4197031 9.18040259,13.4197031 L10.831545,13.4197031 C12.2788426,13.4197031 13.4407576,12.1889339 13.4407576,10.6558704 C13.4407576,9.12280702 12.2788426,7.89203779 10.831545,7.89203779 L7.99810311,7.89203779 C7.99810311,7.89203779 7.83502732,7.89203779 7.7738739,7.91363023 C7.61079811,8 7.65156706,8.12955466 7.79425837,8.28070175 L8.79309759,9.33873144 C8.91540443,9.4682861 8.89501996,9.66261808 8.77271312,9.79217274 L8.32425469,10.2672065 C8.20194785,10.3967611 8.05925653,10.3967611 7.93694969,10.2887989 L5.28696809,7.48178138 C5.18504572,7.37381916 5.18504572,7.20107962 5.28696809,7.09311741 L7.91656522,4.30769231 C8.03887206,4.17813765 8.2427168,4.17813765 8.34463917,4.30769231 L8.77271312,4.7611336 C8.89501996,4.89068826 8.89501996,5.10661269 8.77271312,5.2145749 L7.7738739,6.27260459 C7.65156706,6.40215924 7.65156706,6.55330634 7.85541179,6.55330634 L7.99810311,6.55330634 L10.831545,6.57489879 C12.9515303,6.57489879 14.6842105,8.38866397 14.6842105,10.6558704 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-devices-elements2-Copy",
    transform: "translate(-440.000000, -840.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_revert",
    transform: "translate(440.000000, 840.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17,0 C18.6568542,-3.04359188e-16 20,1.34314575 20,3 L20,17 C20,18.6568542 18.6568542,20 17,20 L0,20 L0,20 L0,0 Z",
    id: "Rectangle",
    fill: "#005082"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    transform: "translate(9.947368, 9.473684) rotate(-359.000000) translate(-9.947368, -9.473684) ",
    xlinkHref: "#path-1"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevert);
export default __webpack_public_path__ + "static/media/icon_revert.71d482593b05d342be7bde5b54e9d68d.svg";
export { ForwardRef as ReactComponent };